/* =========================================================================
 * Unit conversion + formatting helpers driven by user settings.
 * All inputs assumed metric (°C, km/h, hPa, km) — the units these come
 * from in our Open-Meteo / engine payload — and converted at display
 * time only.
 * ===================================================================== */

export function formatTemp(celsius, unit = "C", { decimals = 0, suffix = "°" } = {}) {
  if (celsius == null || Number.isNaN(celsius)) return "—";
  const value = unit === "F" ? celsius * 9 / 5 + 32 : celsius;
  const fixed = decimals > 0 ? value.toFixed(decimals) : Math.round(value).toString();
  return suffix ? `${fixed}${suffix}` : fixed;
}

export function tempUnitLabel(unit = "C") {
  return unit === "F" ? "°F" : "°C";
}

export function formatWind(kmh, unit = "kmh", { decimals = 0 } = {}) {
  if (kmh == null || Number.isNaN(kmh)) return "—";
  let value = kmh;
  switch (unit) {
    case "mph":
      value = kmh * 0.621371;
      break;
    case "ms":
      value = kmh / 3.6;
      break;
    case "kt":
    case "knots":
      value = kmh * 0.539957;
      break;
    default:
      value = kmh;
  }
  return decimals > 0 ? value.toFixed(decimals) : Math.round(value).toString();
}

export function windUnitLabel(unit = "kmh") {
  switch (unit) {
    case "mph": return "mph";
    case "ms": return "m/s";
    case "kt":
    case "knots": return "kt";
    default: return "km/h";
  }
}

export function formatPressure(hPa, unit = "hPa", { decimals } = {}) {
  if (hPa == null || Number.isNaN(hPa)) return "—";
  if (unit === "inHg") {
    const value = hPa * 0.02953;
    return value.toFixed(decimals != null ? decimals : 2);
  }
  return decimals != null ? hPa.toFixed(decimals) : Math.round(hPa).toString();
}

export function pressureUnitLabel(unit = "hPa") {
  return unit === "inHg" ? "inHg" : "hPa";
}

export function formatDistance(km, unit = "km", { decimals = 0 } = {}) {
  if (km == null || Number.isNaN(km)) return "—";
  const value = unit === "mi" ? km * 0.621371 : km;
  return decimals > 0 ? value.toFixed(decimals) : Math.round(value).toString();
}

export function distanceUnitLabel(unit = "km") {
  return unit === "mi" ? "mi" : "km";
}

export function formatTime(iso, format = "24h") {
  if (!iso) return "—";
  const d = iso instanceof Date ? iso : new Date(iso);
  return d.toLocaleTimeString([], {
    hour: "numeric",
    minute: "2-digit",
    hour12: format === "12h",
  });
}
